import { render, staticRenderFns } from "./uf_is_available_import_potential.vue?vue&type=template&id=6f46b918&scoped=true&v-if=%24parent.%24parent.rerender"
import script from "./uf_is_available_import_potential.vue?vue&type=script&lang=js"
export * from "./uf_is_available_import_potential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46b918",
  null
  
)

export default component.exports